import { render } from "./OtpVerification.vue?vue&type=template&id=dc1b6d7e&scoped=true"
import script from "./OtpVerification.vue?vue&type=script&lang=js"
export * from "./OtpVerification.vue?vue&type=script&lang=js"

import "./OtpVerification.vue?vue&type=style&index=0&id=dc1b6d7e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc1b6d7e"]])

export default __exports__